import { css } from '@emotion/css';
import { colors } from '@/colors';

export const styPillsContainer = ({ disabled, fluid, variant }) => css`
  width: fit-content;
  padding: 8px;
  border-radius: 8px;
  background: transparent;
  line-height: 18px;

  ${fluid &&
  `
    width: 100%;
  `}

  ${!disabled &&
  `
    cursor: pointer;
  `}

  ${variant === 'outline' &&
  `
    border: 1px solid ${colors.NEUTRAL_3};
  `}

  &.active,
  &:hover {
    background-color: ${colors.AJAIB_BLUE_1};

    ${variant === 'outline' &&
    `
      border: 1px solid ${colors.AJAIB_BLUE_5};
    `}
  }
`;

export const styPillsText = (props) => css`
  font-size: ${props.size === 'lg' ? '14px' : '12px'};
  font-weight: 700;
  margin: 0;
  color: ${props.active ? colors.NEUTRAL_10 : colors.NEUTRAL_7};
`;
